import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { useAllCoursesForStudent, useProfile } from '@/store';

type Props = {
  value?: string | string[];
  onChange?: (value: string | string[]) => void;
  placeholder?: string;
  styles?: React.CSSProperties;
  mode?: 'multiple' | 'tags';
  suffixIcon?: React.ReactNode;
};

export const CoursesForStudentSelector: React.FC<Props> = ({
  value,
  onChange,
  placeholder,
  styles,
  mode,
  suffixIcon
}) => {
  const { t } = useTranslation();
  const { profile } = useProfile();
  const { courses = [] } = useAllCoursesForStudent(profile!);

  const options = courses.map(c => ({ label: c.name, value: c._id }));

  return (
    <Select
      mode={mode}
      showSearch
      style={styles}
      options={options}
      onChange={onChange}
      value={value}
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      placeholder={placeholder ?? t('SELECT_COURSE')}
      suffixIcon={suffixIcon}
    />
  );
};
